<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [user]="feedback.author"
            [mode]="'avatar'"
          ></ngx-view-user-display>
        </div>

        <div>
          <ngx-view-user-display
            [user]="feedback.author"
            [mode]="'name'"
          ></ngx-view-user-display>
          <ngx-view-time-ago
            [currentDate]="feedback.createdOn"
          ></ngx-view-time-ago>

          <div>
            <button
              nbButton
              ghost
              size="small"
              [status]="
                feedback.category == 'Góp ý'
                  ? 'success'
                  : feedback.category == 'Báo lỗi'
                  ? 'warning'
                  : 'info'
              "
            >
              <nb-icon
                [icon]="
                  feedback.category == 'Góp ý'
                    ? 'bulb-outline'
                    : feedback.category == 'Báo lỗi'
                    ? 'alert-triangle-outline'
                    : 'question-mark-circle-outline'
                "
              ></nb-icon>
              <span> {{ feedback.category }} </span>
            </button>

            <button
              nbButton
              ghost
              size="small"
              [status]="feedback.status == 1 ? 'info' : 'success'"
            >
              <nb-icon icon="flag-outline"></nb-icon>
              <span>{{ feedback.status == 1 ? "Đã gửi" : "Đã ghi nhận" }}</span>
            </button>
          </div>

          <div class="text-link">
            <nb-icon icon="hash-outline"></nb-icon>
            <ngx-view-tags
              [tags]="feedback.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        *ngIf="feedback.createdBy === uid"
        nbButton
        ghost
        status="danger"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="delete(feedback)"
      >
        <nb-icon icon="trash-2-outline"></nb-icon>
      </button>

      <button
        *ngIf="feedback.createdBy === uid"
        nbButton
        ghost
        status="info"
        size="small"
        [disabled]="submitted"
        [class.btn-pulse]="submitted"
        (click)="edit(feedback)"
      >
        <nb-icon icon="edit-2-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body *ngIf="mode != 'detail'">
    <h6 class="text-heading">{{ feedback.title }}</h6>
    <div class="text-hint">{{ feedback.description }}</div>

    <a
      *ngIf="feedback.sourceType && !isMore"
      (click)="loadContent(true)"
      class="link"
    >
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Xem thêm
    </a>

    <nb-card *ngIf="feedback.sourceType && isMore">
      <nb-card-body
        *ngIf="feedback.sourceType == 'images' && feedback.imagesUrl.length > 0"
      >
        <ngx-view-gallery [imagesUrl]="feedback.imagesUrl"> </ngx-view-gallery>
      </nb-card-body>

      <nb-card-body
        *ngIf="feedback.sourceType == 'video' && feedback.videoUrl != ''"
      >
        <ngx-view-video [url]="feedback.videoUrl"></ngx-view-video>
      </nb-card-body>

      <nb-card-body
        *ngIf="feedback.sourceType == 'document' && feedback.content != ''"
      >
        <ngx-view-document [content]="feedback.content"> </ngx-view-document>
      </nb-card-body>
    </nb-card>

    <a
      *ngIf="feedback.sourceType && isMore"
      (click)="loadContent(false)"
      class="link"
    >
      <nb-icon icon="chevron-up-outline"></nb-icon>
      Thu gọn
    </a>
  </nb-card-body>

  <nb-card-footer>
    <div class="button-actions">
      <ngx-view-like *ngIf="mode == 'detail'" [feedback]="feedback">
      </ngx-view-like>
      <button
        *ngIf="mode != 'detail'"
        nbButton
        ghost
        shape="semi-round"
        size="small"
      >
        <i class="fas fa-thumbs-up"></i>
        <span>{{ feedback.noLiked | number }} </span>
      </button>

      <button
        *ngIf="mode == 'admin' && feedback.status == 1"
        nbButton
        ghost
        status="primary"
        size="small"
        (click)="confirm(feedback)"
      >
        <nb-icon icon="checkmark-circle-outline"></nb-icon>
        <span> Ghi nhận</span>
      </button>

      <button nbButton ghost status="info" size="small" (click)="reply()">
        <nb-icon icon="message-square-outline"></nb-icon>

        <div *ngIf="!feedback.noComment || feedback.noComment == 0">
          Bình luận
        </div>

        <div *ngIf="feedback.noComment > 0" style="text-transform: lowercase">
          &nbsp;Xem <span>{{ feedback.noComment | number }} </span> bình luận
        </div>
      </button>
    </div>

    <nb-card *ngIf="view === 'replies'" class="replies">
      <nb-card-body>
        <ngx-view-comments
          [feedback]="feedback"
          [mode]="mode"
          (onClose)="closeReply()"
        >
        </ngx-view-comments>
      </nb-card-body>
    </nb-card>
  </nb-card-footer>
</nb-card>
